(() => {
  if (window.AlphaRecentlyViewed) return;

  const key = 'alphaRecentlyViewedProducts';
  const maxItems = 12;

  const read = () => {
    try {
      const items = JSON.parse(window.localStorage.getItem(key) || '[]');
      return Array.isArray(items) ? items.filter((item) => item?.url && item?.title) : [];
    } catch (_error) {
      return [];
    }
  };

  const write = (items) => {
    try {
      window.localStorage.setItem(key, JSON.stringify(items.slice(0, maxItems)));
    } catch (_error) {
      // Storage can be unavailable in strict privacy modes.
    }
  };

  const add = (product) => {
    if (!product?.url || !product?.title) return;
    const url = new URL(product.url, window.location.origin);
    const normalizedProduct = {
      ...product,
      url: `${url.pathname}${url.search}${url.hash}`,
    };
    const items = read().filter((item) => item.url !== normalizedProduct.url);
    write([normalizedProduct, ...items]);
  };

  window.AlphaRecentlyViewed = { get: read, add };

  const trackCurrentProduct = () => {
    const dataNode = document.getElementById('AlphaViewedProductData');
    if (!dataNode) return;
    try {
      add(JSON.parse(dataNode.textContent || '{}'));
    } catch (_error) {
      // Ignore malformed tracking data.
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', trackCurrentProduct, { once: true });
  } else {
    trackCurrentProduct();
  }
})();
